import { render, staticRenderFns } from "./modificarDepara.vue?vue&type=template&id=26524806"
import script from "./modificarDepara.vue?vue&type=script&lang=js"
export * from "./modificarDepara.vue?vue&type=script&lang=js"
import style0 from "./modificarDepara.vue?vue&type=style&index=0&id=26524806&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports